"use client"
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_sonner__ from "sonner";
const Toaster = ({ type, ...props })=>{
    switch(type){
        case "live":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_sonner__.Toaster, {
                theme: "dark",
                className: "toaster group",
                gap: 8,
                mobileOffset: {
                    bottom: 45
                },
                toastOptions: {
                    style: {
                        backgroundColor: "rgba(35, 39, 46, 0.7)",
                        backdropFilter: "blur(24px)",
                        color: "#FFFFFF",
                        borderRadius: "200px",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        boxShadow: "5px 5px 9px 0px rgba(0,0,0,0.24)"
                    }
                },
                ...props
            });
        case "editor":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_sonner__.Toaster, {
                theme: "dark",
                className: "toaster group",
                gap: 8,
                offset: {
                    right: 425,
                    top: 80
                },
                mobileOffset: {
                    top: 70
                },
                toastOptions: {
                    style: {
                        userSelect: "none",
                        backdropFilter: "blur(24px)",
                        backgroundColor: "rgba(35, 39, 46, 0.8)",
                        color: "#FFFFFF",
                        borderRadius: "14px",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        boxShadow: "5px 5px 9px 0px rgba(0,0,0,0.24)"
                    }
                },
                ...props
            });
        case "dashboard":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_sonner__.Toaster, {
                gap: 8,
                toastOptions: {
                    style: {
                        userSelect: "none",
                        backdropFilter: "blur(24px)",
                        backgroundColor: "rgba(35, 39, 46, 0.8)",
                        color: "#FFFFFF",
                        borderRadius: "14px",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        boxShadow: "5px 5px 9px 0px rgba(0,0,0,0.24)"
                    }
                },
                ...props
            });
    }
};
export { Toaster };
